export interface IPart {
  id: string;
  page: string;
  position: string;
  partsName: string;
  quantity: number;
}
